module.exports = __webpack_public_path__ + "static/media/FILEGENIX_logo.5c1ada95.png";